const SETTINGS_ACTIONS = {
  USER_PARAM: {
    PENDING: 'USER_PARAM_PENDING',
    SUCCESS: 'USER_PARAM_SUCCESS',
    FAILURE: 'USER_PARAM_FAILURE',
  },
}

export const USER_PARAM_STATE = {
  IN_PROGRESS: 'USER_PARAM_PROGRESS',
  SUCCESS: 'USER_PARAM_RETRIEVED',
  ERROR: 'USER_PARAM_ERROR',
}

export default SETTINGS_ACTIONS
